module.exports = __webpack_public_path__ + "static/media/igdb.9cc1b0f9.png";